import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const HeroSection = () => {
  useEffect(() => {
    // Initialize parallax effect
    const heroElements = document.querySelectorAll('.parallax-element');
    
    heroElements.forEach(element => {
      gsap.to(element, {
        y: element.dataset.speed * 100 || -50,
        ease: 'none',
        scrollTrigger: {
          trigger: '#hero',
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    });
    
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []); // gsap and ScrollTrigger are stable, element is queried inside effect

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background gradients */}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-primary-500/10 blur-[120px] parallax-element" data-speed="-0.2"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-accent-gold/10 blur-[120px] parallax-element" data-speed="0.2"></div>
      
      <div className="container-custom relative z-10 py-24">
        <div className="flex flex-col items-center text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mb-12"
          >
            <img 
              src="/images/caishen-logo.jpg" 
              alt="Caishen Capital" 
              className="h-60 md:h-80 object-contain" 
            />
          </motion.div>
          
          <motion.h1 
            className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Investing in <span className="text-gradient">transformative</span> technologies
          </motion.h1>
          
          <motion.p 
            className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-12"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            A family office specializing in venture capital investments across cyberwarfare, AI, fintech, and hydrocarbon sectors.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <a 
              href="#portfolio" 
              className="btn-primary text-lg px-10 py-4"
            >
              Our Portfolio
            </a>
          </motion.div>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute -bottom-20 left-0 right-0 h-40 bg-gradient-to-t from-black to-transparent"></div>
      
      {/* Scroll indicator */}
      <motion.div 
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center text-gray-400"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
      >
        <span className="text-sm mb-2">Scroll to explore</span>
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="w-6 h-10 rounded-full border-2 border-gray-500 flex justify-center pt-1"
        >
          <motion.div
            animate={{ height: [6, 12, 6] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="w-1 bg-accent-gold rounded-full"
          ></motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;